import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../shared/store/TextViewStore';

export interface TextViewerShellProps {
  children: React.ReactNode;
}

/** Texts 우측 패널(TextViewer / MultiTextViewer / IndexTextViewer) 래퍼 */
const TextViewerShell: React.FC<TextViewerShellProps> = ({ children }) => {
  const isLargeBody = useTextViewStore((s) => s.isLargeBody);

  return <Shell $isExtended={isLargeBody}>{children}</Shell>;
};

const Shell = styled.section<{ $isExtended: boolean }>`
  position: relative;
  width: ${({ $isExtended }) => ($isExtended ? 'calc(38vw * 1.2)' : '38vw')};
  max-width: ${({ $isExtended }) => ($isExtended ? '720px' : '600px')};
  height: 100%;
  flex-shrink: 0;
  transition: width 0.3s ease, max-width 0.3s ease;

  display: flex;
  flex-direction: column;

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-bottom: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

export default TextViewerShell;
